
namespace RioERP.Masters {

    @Serenity.Decorators.registerClass()
    export class SmtpSettingsGrid extends Serenity.EntityGrid<SmtpSettingsRow, any> {
        protected getColumnsKey() { return SmtpSettingsColumns.columnsKey; }
        protected getDialogType() { return SmtpSettingsDialog; }
        protected getIdProperty() { return SmtpSettingsRow.idProperty; }
        protected getInsertPermission() { return SmtpSettingsRow.insertPermission; }
        protected getLocalTextPrefix() { return SmtpSettingsRow.localTextPrefix; }
        protected getService() { return SmtpSettingsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}